import OrganizationName from './OrganizationName'

export default OrganizationName
